import dayjs from 'dayjs';
import type { ZangiaPlusAdditionalKey } from '@/shared/user/dashboard';
import {
  plusCopy,
  type PlusSelectableFeatureId,
} from '../components/zangiaplus/plusCopy';

export function plusRemindStorageKey(userId: number) {
  return `zangia-plus-remind-${userId}`;
}

export function formatPlusDate(unix: number) {
  if (!unix) return '—';
  return dayjs.unix(unix).format('YYYY.MM.DD');
}

export function formatPlusDateTime(unix: number) {
  if (!unix) return '—';
  return dayjs.unix(unix).format('YYYY.MM.DD HH:mm');
}

export function remainingPlusDays(
  expireUnix: number,
  nowUnix = dayjs().unix()
) {
  return Math.max(0, Math.ceil((expireUnix - nowUnix) / 86400));
}

export function plusDurationDays(startUnix: number, expireUnix: number) {
  if (!startUnix || !expireUnix || expireUnix <= startUnix) return 0;
  return Math.max(1, Math.round((expireUnix - startUnix) / 86400));
}

export function plusPaymentLabel(type: string, isEnglish = false) {
  const t = isEnglish ? plusCopy.en : plusCopy.mn;
  switch (type) {
    case 'qpay':
      return 'QPay';
    case 'socialpay':
      return 'SocialPay';
    case 'balance':
    case 'pay':
      return t.balancePay;
    default:
      return type || '—';
  }
}

export function plusHistoryPeriod(startUnix: number, expireUnix: number) {
  if (!startUnix || !expireUnix) return '—';
  return `${dayjs.unix(startUnix).format('MM.DD')} – ${dayjs.unix(expireUnix).format('MM.DD')}`;
}

export function toPlusAdditionalKey(
  id: PlusSelectableFeatureId
): ZangiaPlusAdditionalKey {
  return id === 'cvtop' ? 'zplus_cvtop' : 'zplus_suggesttop';
}
